export default __webpack_public_path__ + "static/media/features-shop.389b9d1d.svg";